import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class PageHeaderService {
  private readonly timerTextSignal = signal<string | null>(null);
  private readonly timerUrgentSignal = signal(false);
  readonly timerText = this.timerTextSignal.asReadonly();
  readonly timerUrgent = this.timerUrgentSignal.asReadonly();

  setTimerText(text: string, urgent = false): void {
    this.timerTextSignal.set(text);
    this.timerUrgentSignal.set(urgent);
  }

  clearTimerText(): void {
    this.timerTextSignal.set(null);
    this.timerUrgentSignal.set(false);
  }
}
